<template>
  <div>
    <p><i class="el-icon-s-grid"></i>修改密码</p>
    <el-divider></el-divider>
    <el-form ref="form" :model="form" label-width="100px" style="max-width: 20rem;">
      <el-form-item label="原密码">
        <el-input type="password" v-model="form.password" show-password></el-input>
      </el-form-item>
      <el-form-item label="新密码">
        <el-input type="password" v-model="form.newpass" show-password></el-input>
      </el-form-item>
      <el-form-item label="重复新密码">
        <el-input type="password" v-model="form.renewpass" show-password></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">保存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
  import { userPwd } from '../../api/userMG'
  export default {
    data() {
      return {
        form: {
          password: '',
          newpass: '',
          renewpass: ''
        }
      }
    },
    methods: {
      onSubmit() {
        userPwd(this.form).then(res=>{
          if(res.code == 1){
            this.$message({
              type: 'success',
              message: res.msg
            })
          }else{
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        }).catch(err=>{
          this.$message({
            type: 'info',
            message: '未知错误'
          })
        })
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/views/huoma/editPass.vue